import { URL_REGEX } from './regex'

export function convertEmailToName(email: string): string {
  const getEmailUsername = email.split('@')[0]
  return getEmailUsername.split('.').join(' ')
}

export function capitalizeFirstLetter(string: string) {
  return string.charAt(0).toUpperCase() + string.slice(1)
}

export function stripHTMLTags(originalString: string) {
  return !!originalString
    ? originalString.replace(/(<([^>]+)>)/gi, ' ').trim()
    : originalString
}

export function truncateWordsByChar(str, maxLen, separator = ' ') {
  if (str.length <= maxLen) {
    return str
  }
  return str.substr(0, str.lastIndexOf(separator, maxLen)) + '...'
}

export function getUrlsFromText(text): string[] {
  return text?.match(URL_REGEX)
}

export function extractYTIdFromUrl(url) {
  let regExp =
    /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/
  let match = url.match(regExp)
  if (match && match[7].length === 11) {
    return match[7]
  }
  return ''
}

export function removeTagsStyleAttribute(string: string, replacement = '') {
  return string.replace(
    /(style=[",'])([a-zA-Z0-9:;.\s()\-,]*)([",'])/gi,
    replacement
  )
}

/**
 * Concatenates an array of strings into a string, delimited with commas (,) with inclusion of the 'Oxford comma'
 *
 * @example
 * // returns "Geometri"
 * oxfordConcat(['Geometri'])
 * @example
 * // returns "Geometri dan Aljabar"
 * oxfordConcat(['Geometri', 'Aljabar'])
 * @example
 * // returns "Geometri, Aljabar, dan Kalkulus"
 * oxfordConcat(['Geometri', 'Aljabar', 'Kalkulus'])
 *
 * @param {string[]} texts - Array of strings to process
 * @param {string} [conjunction=dan] - Conjunction to insert before the last item
 * @returns {string} The concatenated string
 */
export function oxfordConcat(texts: string[], conjunction = 'dan') {
  const len = texts.length

  if (len <= 0) return ''
  if (len < 2) return texts[0]
  if (len < 3) return texts.join(` ${conjunction} `)

  let result = texts.slice()
  result[len - 1] = `${conjunction} ${texts[len - 1]}`

  return result.join(', ')
}

/**
 * Removes queries and hashes from a URL
 * @param {string} url URL to be processed
 * @returns {string} Processed URL
 */
export function removeQuery(url: string): string {
  return url.split('?')[0].split('#')[0]
}

export const toKebabCase = (str) =>
  str &&
  str
    .match(/[A-Z]{2,}(?=[A-Z][a-z]+[0-9]*|\b)|[A-Z]?[a-z]+[0-9]*|[A-Z]|[0-9]+/g)
    .map((x) => x.toLowerCase())
    .join('-')

/**
 * @param {string} str Input text
 * @param {boolean} replaceMode Use replace instead of insert
 * @param {boolean} isXhtml Use XHTML
 * @return {string} Filtered text
 */
export function nl2br(str, replaceMode = true, isXhtml = true) {
  let breakTag = isXhtml ? '<br />' : '<br>'
  let replaceStr = replaceMode ? '$1' + breakTag : '$1' + breakTag + '$2'
  return (str + '').replace(/([^>\r\n]?)(\r\n|\n\r|\r|\n)/g, replaceStr)
}

export function getNameFromFileUrl(url: string, bucketName: string) {
  // separator is defined as "=-". Also split on encoded string of "=-"
  const split = url
    ?.split?.('=-')
    ?.pop?.()
    ?.split?.('%3D-')
    ?.pop?.()
    ?.split(`${bucketName}/`)
    ?.pop?.()
  // decode URL encoded filename (convert %20 into space)
  const decodedFileName = decodeURIComponent(split)

  // eslint-disable-next-line no-extra-boolean-cast
  return !!split ? decodedFileName : url
}

export function capitalizeEachWords(text: string): string {
  if (!Boolean(text)) {
    return text
  }

  return text
    ?.split(' ')
    ?.map((word) => word[0].toUpperCase() + word.substring(1).toLowerCase())
    ?.join(' ')
}
